import { useParams } from 'react-router-dom';

export function useAuthorizationId() {
  const { authorizationId } = useParams<{ authorizationId?: string }>();

  return authorizationId;
}
